import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";


const CustomFileInputWrapper = styled.input`
    color: transparent; 
    outline: 0;
    
    width: 146px;
    height: 28px;

    > div {
      width: fit-content;
    }
    &::-webkit-file-upload-button {
      visibility: hidden;
    }
    &::before {
        width: calc(100% - 0.125rem);
        text-align: center;
        content: ${props => props.label ? `'${props.label}'` : "'Choose File'"};
        color: var(--color-gray-600);
        display: inline-block;
        border: 1px solid var(--color-gray-600);
        box-sizing: border-box;
        border-radius: 4px;
        padding: var(--space-s) 0;
        outline: none;
        white-space: nowrap;
        -webkit-user-select: none;
        cursor: pointer;
        font-weight: 500;
        font-family: Metropolis;
        font-style: normal;
        line-height: 12px;
        /* identical to box height */
        
        font-size: var(--font-xs);
        transition: 0.2s background-color ease-in;
    }
    &:hover::before {
      background-color: var(--gray-secondary);
    }
    &:active {
      outline: 0;
      &::before {
    }
}
`;


function CustomFileInput({onChange, label}) {
    return (
        <CustomFileInputWrapper type={"file"} onChange={onChange} label={label}/>
    );
}

CustomFileInput.propTypes = {};
CustomFileInput.defaultProps = {};

export default CustomFileInput;
